var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-action-btn',{attrs:{"tooltip":_vm.$t('filter.selector.buttons.list'),"disabled":_vm.disabled,"icon":"filter_list"},on:{"click":_vm.showFiltersListModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }